/* use global */

const isParamValueValid = paramValue => paramValue !== '' && paramValue !== '*';

export const parserFunction = ({endpoint, searchType, params}) => {
  const paramsString = Object.keys(params).reduce(
    (accum, key) =>
      isParamValueValid(params[key]) ? `${accum}${accum === '' ? '?' : '&'}${key}=${params[key]}` : accum,
    ''
  );
  // eslint-disable-next-line no-undef
  return `${Config.base.sandwichUrl}${endpoint}/${searchType}${paramsString}`;
};
